import { registerApplication, start, navigateToUrl } from 'single-spa';
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from 'single-spa-layout';
import DatamartLogo from './assets/images/datamart-logo.svg';

const routes = constructRoutes(document.querySelector('#single-spa-layout'), {
  loaders: {
    loading: `<div id="global-spinner" class="spinner">
                <div class="blob blob-0">
                  <img src="${DatamartLogo}" alt=""></img>
                </div>
              </div>`,
    loadingWithSidebar: `<div id="global-spinner" class="spinner spinner-sidebar">
    <div class="blob blob-0">
      <img src="${DatamartLogo}" alt=""></img>
    </div>
  </div>`,
  },
});
const applications = constructApplications({
  routes,
  loadApp: ({ name }) => System.import(name),
});

// Delay starting the layout engine until the styleguide CSS is loaded
const layoutEngine = constructLayoutEngine({
  routes,
  applications,
  active: false,
});

applications.forEach(registerApplication);

System.import('@dm-portal/styleguide').then(() => {
  // Activate the layout engine once the styleguide CSS is loaded
  layoutEngine.activate();
  start({
    urlRerouteOnly: true,
  });
});

window.addEventListener(
  'single-spa:before-routing-event',
  ({ detail: { oldUrl, newUrl } }) => {
    /** Redirect login or home */
    if (!localStorage.getItem('user-profile')) {
      const currentPath = new URL(newUrl).pathname;
      if (!currentPath.includes('/auth/')) {
        navigateToUrl('/auth/login');
      }
    } else {
      if (new URL(newUrl).pathname === '/auth/login' && (new URL(oldUrl).pathname !== '/auth/sign_up' && new URL(oldUrl).pathname !== '/auth/reset')) {
        window.history.back();
      }
    }
  }
);
